import React, { useEffect, useState } from "react";
import UserLayout from "../../../../components/user-layout/UserLayout";

import authService from "../../../../utils/services/authService";
import { useParams } from "react-router-dom";
import DeveloperUpdate from "../../../../components/admin/management/users/DeveloperUpdate";
import CompanyUpdate from "../../../../components/admin/management/users/CompanyUpdate";

const UserMgmtUpdate = () => {
  const [user, setUser] = useState();

  const userData = authService.getUserData();
  const { id, role } = useParams();

  useEffect(() => {
    if (role === "developer") {
      authService.getDeveloperById(userData, id).then((res) => {
        if (res.data.success) {
          setUser(res.data.data[0]);
        }
      });
    } else if (role === "company") {
      authService.getCompanyById(userData, id).then((res) => {
        if (res.data.success) {
          setUser(res.data.data[0]);
        }
      });
    }
  }, []);
  return (
    <UserLayout>
      {role === "developer" && user && <DeveloperUpdate user={user} />}
      {role === "company" && user && <CompanyUpdate user={user} />}
    </UserLayout>
  );
};

export default UserMgmtUpdate;
